import { LOGIN, LOGOUT, toLoggedUser } from "./auth";

const UPDATE_PASSENGERS = "plt-web/passengers/UPDATE_PASSENGERS";

const initialState = {
	adults: [],
	children: [],
	infants: [],
	email: "",
	phone_number: "",
	password: "",
};

export default function reducer(state, { type, ...action }) {
	if (!state) {
		state = initialState;
	}
	switch (type) {
		case UPDATE_PASSENGERS: {
			return action.data;
		}
		case LOGIN: {
			const user = toLoggedUser(action.payload);

			return {
				...state,
				email: user.email,
				confirmEmail: user.email,
				isAuthenticated: true,
				phone_number: user.phone,
				password: "",
			};
		}
		case LOGOUT: {
			return {
				...state,
				isAuthenticated: false,
				email: "",
				confirmEmail: "",
				phone_number: "",
				password: "",
			};
		}
		default:
			return state;
	}
}

export const updatePassengers = (
	data = { adults: [], children: [], infants: [] },
) => ({
	type: UPDATE_PASSENGERS,
	data,
});
